function refreshCart() {
	$.ajax({
	  url: '/cart?view=sidecart',
	  dataType: 'HTML',
	  method: "GET",
	  success: function (htmlData) {
        let html_markup = $(htmlData);
        let data_replace = $(htmlData).html();
		 
		$("#shopify-section-cw-cart-drawer").find('div.js_slidecart').html(data_replace);
        //$('.js_slidecart').html(data_replace);
        let cart_count = $(`[data-cart-itemcount]`).attr('data-cart-itemcount');
        $('.count-item').text(cart_count);
        // console.log(cart_count);
		$.get('/cart.json', function (cart) {
		  $.each(cart.items, function (index, item) {
				$(`[data-prodsuggest='${item.product_id}']`).hide();
			 	$(`[data-freegift='${item.product_id}']`).hide();
				
			});
		  });
		  if ($('.upsells').length > 0) {
			$('.upsells').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: true,
				dots:false,
				prevArrow: '<button type="button" class="prev-arrow"><span class="icon-left-open"></span></button>',
				nextArrow: '<button type="button" class="next-arrow"><span class="icon-right-open"></span></button>',	
				lazyLoad: 'progressive',
				infinite: true,
				draggable:false,				
			});	
		}
		 
    //$("body").toggleClass("showcart");
    
	 }
	});
  }

if (navigator.userAgent.indexOf('Mac') > 0)
$('body').addClass('mac-os');
if (navigator.userAgent.indexOf('Safari') > 0)
$('body').addClass('safari');
if (navigator.userAgent.indexOf('Chrome') > 0)
$('body').addClass('chrome');

$(document).ready(function(){	
	jQuery('.scrollTo').click(function(e) {
        var jump = jQuery(this).attr('href');
        var new_position = jQuery(jump).offset();
        var scroll = 0;
        jQuery('html, body').stop().animate({ scrollTop: new_position.top + scroll }, 2000, function(){
            var new_position = jQuery(jump).offset();
            jQuery('html, body').stop().animate({ scrollTop: new_position.top + scroll }, 2000);
        });
        e.preventDefault();
    });	
	
	$(".mobile-menu-icon").click(function (e) {
		$("body").toggleClass("show-menu");
		e.stopPropagation();
	});
	$(".menu li a,.close_menu").click(function () {
		$("body").removeClass("show-menu");
		e.stopPropagation();
	});
	$(document).mouseup(function(e) {
		var container = $(".sidebar-menu,.slidecarthq");
		if (!container.is(e.target) && container.has(e.target).length === 0){
			$('body').removeClass('show-menu').removeClass('showcart');
		}
	});
	$(".header-cart").click(function (e) {
		$("body").toggleClass("showcart");
		refreshCart();
		 
	});
	
	$(document).on('click','.slidecarthq .header button',function(e){
	    e.preventDefault();
		refreshCart();
		$("body").removeClass("showcart");
		 
	});
	
	$('.search-toggle-btn, .close-search').on('click', function(){
		$('.search-toggle-wrapper').stop().toggleClass('show-search-bar');
	});
	
	
		$('.faq-accordion .item').click(function(){
			$(this).toggleClass(' active ');
			$(this).siblings().removeClass(' active '); 
			$('.faq-answer').stop().slideUp();
			$('.active .faq-answer').stop().slideDown();
			return false;
		});
		
	
	$('.faq-answer').click(function(){
		if ($('.faq-accordion .item').hasClass('active')){
			$('.faq-accordion .item').removeClass('active');
		} else {
			$('.faq-accordion .item').addClass('active');
		}		
	});
	
	if($('.category-list').length > 0){
		$('.category-list .item').click(function(){
			$(this).toggleClass(' active ');
			$(this).siblings().removeClass(' active '); 
			$('.sub-item').stop().slideUp();
			$('.active .sub-item').stop().slideDown();
			return false;
		});
	}
	
	if ($('.product-list-slider').length > 0) {		
		$('.product-list-slider').slick({
			slidesToShow: 3,
			slidesToScroll: 1,
			lazyLoad: 'progressive',
			arrows: true,
			dots: false,	
			infinite: true,
			prevArrow: '<button type="button" class="prev-arrow "><span class="icon-left-open"></span></button>',
			nextArrow: '<button type="button" class="next-arrow "><span class="icon-right-open"></span></button>',			
			responsive: [
				{
					breakpoint: 767,
					settings: {
					  slidesToShow: 2,
					}
				},
				{
					breakpoint: 575,
					settings: {
					  slidesToShow: 1,
					}
				  }
			]		
		});			  
	}
	if ($('.cart-product-slider').length > 0) {		
		$('.cart-product-slider').slick({
			slidesToShow: 4,
			slidesToScroll: 1,
			lazyLoad: 'progressive',
			arrows: true,
			dots: false,	
			infinite: false,
			prevArrow: '<button type="button" class="prev-arrow"><span class="icon-left-open"></span></button>',
			nextArrow: '<button type="button" class="next-arrow"><span class="icon-right-open"></span></button>',			
			responsive: [	
				{
					breakpoint: 991,
					settings: {
					  slidesToShow: 3,
					}
				},
				{
					breakpoint: 767,
					settings: {
					  slidesToShow: 2,
					}
				},
				{
					breakpoint: 575,
					settings: {
					  slidesToShow: 1,
					}
				  }
			]		
		});			  
	}
	if ($('.testimonial-slider').length > 0) {		
		$('.testimonial-slider').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			lazyLoad: 'progressive',
			arrows: true,
			dots: true,	
			infinite: true,
			prevArrow: '<button type="button" class="prev-arrow with-gradiant"><span class="icon-left-open"></span></button>',
			nextArrow: '<button type="button" class="next-arrow with-gradiant"><span class="icon-right-open"></span></button>',	
			responsive: [
				{
					breakpoint: 767,
					settings: {
					  slidesToShow: 2,
					}
				},
				{
					breakpoint: 575,
					settings: {
					  slidesToShow: 1,
					}
				  }
			]						
		});			  
	}
	if($('.review-slider').length > 0) {		
		$('.review-slider').slick({
			slidesToShow: 4,
			slidesToScroll: 1,
			lazyLoad: 'progressive',
			arrows: true,
			dots: false,	
			infinite: true,
			prevArrow: '<button type="button" class="prev-arrow"><span class="icon-left-open"></span></button>',
			nextArrow: '<button type="button" class="next-arrow"><span class="icon-right-open"></span></button>',	
			responsive: [				
				{
				  breakpoint: 991,
				  settings: {
					slidesToShow: 3,
				  }
				},
				{
					breakpoint: 767,
					settings: {
					  slidesToShow: 2,
					}
				},
				{
					breakpoint: 575,
					settings: {
					  slidesToShow: 1,
					}
				  }
			]		
				
		});	
	}
	$('.pdp-tabs ul li a').click(function(){
		$('li a').removeClass("active");
		$(this).addClass("active");
	});
	$('#tabs-faq-section a').on('click', function (e) {
		e.preventDefault()
		$(this).tab('show')
	  })
	$('.modal-toggle-1').on('click', function(e) {
		e.preventDefault();
		$('.modal-1').toggleClass('is-visible');		
	});
	$('.modal-toggle-2').on('click', function(e) {
		e.preventDefault();
		$('.modal-2').toggleClass('is-visible');		
	});	
	if ($('.upsells').length > 0) {
		$('.upsells').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: true,
			dots:false,
			prevArrow: '<button type="button" class="prev-arrow"><span class="icon-left-open"></span></button>',
			nextArrow: '<button type="button" class="next-arrow"><span class="icon-right-open"></span></button>',	
			lazyLoad: 'progressive',
			infinite: true,
			draggable:false,				
		});	
	}
	if ($('.slider-for').length > 0) {
		$('.slider-for').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			dots:false,
			lazyLoad: 'progressive',
			infinite: true,
			draggable:false,
			asNavFor: '.slider-nav',
				
		});	
	}
	if ($('.slider-nav').length > 0) {	
		var test = $(".slider-nav .item").length;	
	}
	if (test <= 7) {
		$(".slider-nav").addClass("show-four-item");
	}
	else{
		$(".slider-nav").removeClass("show-four-item");
	}
	if ($('.slider-nav').length > 0) {			
		$('.slider-nav').slick({
			slidesToShow: 4,
			slidesToScroll: 1,
			lazyLoad: 'progressive',
			asNavFor: '.slider-for',
			arrows: true,
			dots: false,
			infinite: true,			
			focusOnSelect: true,	
			prevArrow: '<button type="button" class="prev-arrow"><span class="icon-left-open"></span></button>',
			nextArrow: '<button type="button" class="next-arrow"><span class="icon-right-open"></span></button>',	
		});			  
	}
	
	if ($('.quantity').length > 0) {	
		 $(document).on('click','.plus',function(e){
			let $input = $(this).prev('input.qty');
			let val = parseInt($input.val());
			$input.val( val+1 ).change();
		});

		$(document).on('click','.minus',function(e){
			let $input = $(this).next('input.qty');
			var val = parseInt($input.val());
			if (val > 0) {
				$input.val( val-1 ).change();
			} 
		});
	}	
	
});

$(window).on("load resize scroll", function (e) {
	if($('.product-box-details h4 ').length > 0 ){
		$('.product-box-details h4').matchHeight({
			byRow: true,
		});
	}
	if($('.product-box-details > ul ').length > 0 ){
		$('.product-box-details > ul').matchHeight({
			byRow: true,
		});
	}
	if($('.product-box-details > .short-description ').length > 0 ){
		$('.product-box-details > .short-description').matchHeight({
			byRow: true,
		});
	}
	
});

const init = {
	autoplay: true,
	infinite: true,
	dots: true,
	slidesToShow: 2,
	slidesToScroll: 1,
	arrows: true,
	prevArrow: '<button type="button" class="prev-arrow"><span class="icon-left-open"></span></button>',
	nextArrow: '<button type="button" class="next-arrow"><span class="icon-right-open"></span></button>',
	responsive: [
		{
			breakpoint: 575,
			settings: {
			  slidesToShow: 1,
			}
		}
	]
}; 
const init2 = {
	infinite: true,
	rows:3,
	dots: true,
	slidesToShow: 1,
	slidesToScroll: 1,
	arrows: true,
	prevArrow: '<button type="button" class="prev-arrow"><span class="icon-left-open"></span></button>',
	nextArrow: '<button type="button" class="next-arrow"><span class="icon-right-open"></span></button>',
	
};  
$(() => {
	const win = $(window);
	const slider = $(".category-list");
	const slider2 = $(".about-item-list");

	win.on("load resize", () => {
		if (win.width() < 767) {
			slider.not(".slick-initialized").slick(init);
		} else if (slider.hasClass("slick-initialized")) {
			slider.slick("unslick");
		}
		if (win.width() < 767) {
			slider2.not(".slick-initialized").slick(init2);
		} else if (slider2.hasClass("slick-initialized")) {
			slider2.slick("unslick");
		}
	});
});

$(document).on('change',`.js-cw-product-page-form [data-option-1] input, .js-cw-product-page-form [data-option-2] input,.js-cw-product-page-form [data-option-3] input`,function(e){
	 
	let option1 = option2 = option3 = null;
	if($(`.js-cw-product-page-form [data-option-1]`).length > 0) {
		option1 = $(`.js-cw-product-page-form [data-option-1] input:checked`).val();
	}
	if($(`.js-cw-product-page-form [data-option-2]`).length > 0) {
		option2 = $(`.js-cw-product-page-form [data-option-2] input:checked`).val();
	}
	if($(`.js-cw-product-page-form [data-option-3]`).length > 0) {
		option3 = $(`.js-cw-product-page-form [data-option-3] input:checked`).val();
	}
	let variant_id = null;
	let current_selected_option = null;
	if(option2 == null & option3 == null) {
	 
		current_selected_option = $(`.js-cw-product-page-form select.actual-variants option[data-option1='${option1}']`);
		variant_id = $(`.js-cw-product-page-form select.actual-variants option[data-option1='${option1}']`).val();
	}
	if(option2 != null & option3 == null) {
	 
		current_selected_option = $(`.js-cw-product-page-form select.actual-variants option[data-option1='${option1}'][data-option2='${option2}']`);
		variant_id = $(`.js-cw-product-page-form select.actual-variants option[data-option1='${option1}'][data-option2='${option2}']`).val();
	}
	if(option2 != null & option3 != null) {
	   
		current_selected_option = $(`.js-cw-product-page-form select.actual-variants option[data-option1='${option1}'][data-option2='${option2}'][data-option3='${option3}']`);
		variant_id = $(`.js-cw-product-page-form select.actual-variants option[data-option1='${option1}'][data-option2='${option2}'][data-option3='${option3}']`).val();
	}
	if(variant_id == null) {
		$(`.js-cw-product-page-form .stock`).fadeOut(100);
		$(`.js-cw-product-page-form .js-out-stock`).fadeIn(100);
		$(`.js-cw-product-page-form .product_page_atc`).addClass('soldout');
		$(`.js-cw-product-page-form .product_page_atc span`).text("Unavailable");
		return true;
	}
	let price = $(current_selected_option).attr('data-price');
	let compare_at_price = $(current_selected_option).attr('data-compareat-price');
    		
	let discount = $(current_selected_option).attr('data-discount');
	let image_src = $(current_selected_option).attr('data-image');
  console.log(image_src);
	let save = $(current_selected_option).attr('data-save');
	let is_available = $(current_selected_option).attr('data-available');
  let klarna_price = $(current_selected_option).attr('klarna-price');
    let klr_price = $(current_selected_option).attr('data-klr-price');
	$(`.js-cw-product-page-form select.actual-variants`).val(variant_id).trigger('change');
  // document.getElementsByTagName("klarna-placement")[0].setAttribute("data-purchase-amount", klr_price );


	 document.getElementsByTagName("klarna-placement")[0].setAttribute("data-purchase-amount", klarna_price);
   window.KlarnaOnsiteService = window.KlarnaOnsiteService || []
   window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' })
	if(is_available == 'true') {
	 	$(`.js-cw-product-page-form .product_page_atc`).removeClass('soldout');
		$(`.js-cw-product-page-form .product_page_atc span`).text("Add to basket");
		$(`.js-cw-product-page-form .product_page_atc`).show();
		$(`.bis_out_stock`).hide();
        $(`.similar-products`).hide();
	} else {
		$(`.js-cw-product-page-form .product_page_atc`).addClass('soldout');
		$(`.js-cw-product-page-form .product_page_atc span`).text("Soldout");
		$(`.js-cw-product-page-form .product_page_atc`).hide();
		$(`.bis_out_stock`).show().attr('data-variant-id', variant_id);
      $(`.similar-products`).show();
	}
	let current_position = null;
	cw.variants.forEach((em,ix) => {
		if( em.id == variant_id && em.featured_image != null ) {
			current_position = em.featured_image.position - 1;
			console.log(current_position);
			$(`.probig.slider-for`).slick('slickGoTo',current_position);
		}
	});
	// var newurl =
	// window.location.protocol +
	// '//' +
	// window.location.host +
	// window.location.pathname +
	// '?variant=' +
	// variant_id;
	//   window.history.replaceState({ path: newurl }, '', newurl);
	/*
	console.log(variant_id);
	console.log(price);
	console.log(compare_at_price);
	console.log(discount);
	console.log(image_src);
	console.log(save);
	*/
});

$(document).on(`click`,`.js-cw-product-page-form .product_page_atc`,function(e){
	e.preventDefault();
	let items = Array();
	let form_data_array = $(`.js-cw-product-page-form`).serializeArray();
	let popUpTrue = $(this).attr('data-upsell-popup');
	let item = {};
	form_data_array.forEach((em,ix) => {
		item[em.name] = em.value;
	});
	items.push(item);
	$.ajax({
		url : "/cart/add.js",
		data : {items : items},
		method : "POST",
		dataType : "JSON",
		success  : function(data) {
			//  window.location = "/cart";
			if( popUpTrue === 'true'){

			}else{
			refreshCart();
			$("body").toggleClass("showcart");
			}
		},
		error:function(data){
			window.alert(data.responseJSON.description);
		}
	});
});

$(document).on(`click`,`.product_page_buy_now`,function(e){
	e.preventDefault();
	let items = Array();
	let form_data_array = $(`.js-cw-product-page-form`).serializeArray();
	let popUpTrue = $(this).attr('data-upsell-popup');
	let item = {};
	form_data_array.forEach((em,ix) => {
		item[em.name] = em.value;
	});
	items.push(item);
	$.ajax({
		url : "/cart/add.js",
		data : {items : items},
		method : "POST",
		dataType : "JSON",
		success  : function(data) {
		 window.location = '/checkout';
		},
		error:function(data){
			window.alert(data.responseJSON.description);
		}
	});
});

$(document).on('click','.remove.js_product_remove',function(e){
	e.preventDefault();
	let current_em = $(e.target);
	let key = $(this).attr('data-pro-key');
	let updated_qty = 0;
	let current_item = {};
	 
	current_item[key] = updated_qty;
	$.ajax({
		url: "/cart/update.js",
		data: { 'updates': current_item },
		method: "POST",
		dataType: "JSON",
		success: function (data) {
			//refreshCart();	
		}, error: function (error) {
			console.log(error)
		}
	});
});


// $(document).on('change', '[name="js_qty"]', function (e) {
// 	let current_em = $(e.target);
// 	let current_item = {};
// 	let key = $(current_em).attr('data-id');
// 	current_item[key] = $(current_em).val();
// 	console.log(key);
	 
// 	$.ajax({
// 		url: "/cart/update.js",
// 		data: { 'updates': current_item },
// 		method: "POST",
// 		dataType: "JSON",
// 		success: function (data) {
// 			//refreshCart()
// 		}, error: function (error) {
// 			alert(data.responseJSON.description);
// 		}
// 	});
// });

  $(document).ready(function(){

  $(document).on('click', '.upsall-product-atc', function (e) {
   
    e.preventDefault();
    var target = e.target;
    var data_id = $(this).attr("data-id");
    
    var quantity = $('.productquantityselect input[data-qty-id="'+data_id +'"]').val();
    $.ajax({
      url :   "/cart/add.js",
      method : "POST",
      dataType : "JSON",
      data : {id : data_id , quantity : quantity},
     
      success : function() {
        window.location = "/checkout";

      }
    });

  });

});




 $(document).ready(function() {
	$('.desktop_article').hide();
	 $('.desktop_article').each(function(index,value) {
	   if(index < 6 ) {
		 $(this).show();
	   }
	 });
	if($('.desktop_article:hidden').length) {
	  $('#seeMore').show();
	}
	if(!$('.desktop_article:hidden').length) {
		$('#seeMore').hide();
	  }
	
  });
  $('#seeMore').on('click', function() {
    $('.desktop_article:hidden').each(function(index, value) {
       if(index < 6) {
         $(this).fadeIn(500);
       }
    });
    if(!$('.desktop_article:hidden').length) {
      $('#seeMore').hide();
    }


});
 
$(document).on(`click`,`#upsell_product`,function(e){
	e.preventDefault();
	var variant_id = $(this).attr('data-upsell-id');
	var quantity = 1;
	console.log(variant_id);
	
	$.ajax({
	  type: 'POST',
	  url: '/cart/add.js',
	  dataType: 'json',
	  data: { id: variant_id, quantity: quantity },
	  success: function(success_data) {
		 refreshCart() ;
    },
	  
	  error: function(data) {
		alert(data.responseJSON.description);
	  }
	});
  });


    /* scroll to target */
	jQuery('.scrollTo').click(function (e) {
		var jump = jQuery(this).attr('href');
		var new_position = jQuery(jump).offset();
		var scroll = 0;
		jQuery('html, body').stop().animate({
		  scrollTop: new_position.top + scroll
		}, 800, function () {
		  var new_position = jQuery(jump).offset();
		  jQuery('html, body').stop().animate({
			scrollTop: new_position.top + scroll
		  }, 800);
		});
		e.preventDefault();
	  });

	  $('.js_text_only').keypress(function (e) {
        var regex = /^[a-zA-Z ]*$/;
		//var letters = /^[A-Za-z]+$/;
        var str = String.fromCharCode(!e.charCode ? e.which : e.charCode);
        if (regex.test(str)) {
			$('.js_text_error').hide();
            return true;
        }
        else
        {
        e.preventDefault();
        
        return false;
        }
    });
	$(function(){
		$(".js_number").keypress(function (e) {
		  if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
		   $("#errmsg").html("Number Only").stop().show().fadeOut("slow");
		   return false;
		 }
		});
	 });


	 $(document).on('click', '.js_qtypluse', function(e) {
        e.preventDefault();
        let parent = $(e.target).parents('.js-qty__wrapper').eq(0);
        let current_qty = $(parent).attr('data-quantity');
        let updated_qty = parseInt(current_qty) + 1;
        let current_item = {};
        let key = $(parent).attr('data-key');
       
	   
        current_item[key] = updated_qty;
        $.ajax({
            url: "/cart/update.js",
            data: {
                'updates': current_item
            },
            method: "POST",
            dataType: "JSON",
            success: function(data) {

                refreshCart();

                $.getJSON('/cart.js', function(cart, textStatus) {
                    $(".count-item").html(cart.item_count);

                });
                $('#sec_cart #cart_form').load('#sec_cart #cart_form > *');

            },
            error: function(error) {
                console.log(error)
            }
        });
    });

	$(document).on('click', '.js_qtyminus', function(e) {
       
        let parent = $(e.target).parents('.js-qty__wrapper').eq(0);
        let current_qty = $(parent).attr('data-quantity');
        let updated_qty = parseInt(current_qty) - 1;
        let current_item = {};
        if (updated_qty <= 0) {
            updated_qty = 0;
        }

        let key = $(parent).attr('data-key');
        current_item[key] = updated_qty;

        $.ajax({
            url: "/cart/update.js",
            data: {
                'updates': current_item
            },
            method: "POST",
            dataType: "JSON",
            success: function(data) {
            
            
                refreshCart();
              $.getJSON('/cart.js', function(cart, textStatus) {
                    $(".count-item").html(cart.item_count);
                    if (cart.item_count == 0) {

                        $('.js_cart_open').removeClass('js_active_class');

                    }
					
					let cartTotal = cart.total_price;
					if(cartTotal < window.freePro1_freeamount){
						 
						$.ajax({
							type: 'POST',
							async: false,
							url: '/cart/change.js',
							data: {
							  quantity: 0,
							  id: window.freePro1_id
							},
							dataType: 'json',
							success: function(cart) {
							    
								refreshCart();
							},
							error: function(XMLHttpRequest, textStatus) {
							  console.log('Error: ' + textStatus);
							}
						  });
					  }
					  if(cartTotal < window.freePro2_freeamount){
						 
						$.ajax({
							type: 'POST',
							async: false,
							url: '/cart/change.js',
							data: {
							  quantity: 0,
							  id: window.freePro2_id
							},
							dataType: 'json',
							success: function(cart) {
							    
								refreshCart();
							},
							error: function(XMLHttpRequest, textStatus) {
							  console.log('Error: ' + textStatus);
							}
						  });
					}
					if(cartTotal < window.freePro3_freeamount){
						 
						$.ajax({
							type: 'POST',
							async: false,
							url: '/cart/change.js',
							data: {
							  quantity: 0,
							  id: window.freePro3_id
							},
							dataType: 'json',
							success: function(cart) {
							   
								refreshCart();
							},
							error: function(XMLHttpRequest, textStatus) {
							  console.log('Error: ' + textStatus);
							}
						  });
					}
					 if(cartTotal < window.freePro4_freeamount){
						 
						$.ajax({
							type: 'POST',
							async: false,
							url: '/cart/change.js',
							data: {
							  quantity: 0,
							  id: window.freePro4_id
							},
							dataType: 'json',
						    success: function(cart) {
							   
								refreshCart();
							},
							error: function(XMLHttpRequest, textStatus) {
							  console.log('Error: ' + textStatus);
							}
						  });
					}
                });
              
                $('#sec_cart #cart_form').load('#sec_cart #cart_form > *');
              
            },
            error: function(error) {
                console.log(error)
            }
        });
    });
	
	$(document).on('click','.js_checkout_def',function(e){
	    e.preventDefault();
		window.location = "/checkout" 
	});
	
	$(document).on('click', '.js-product-quantity-remove', function(e) {

        e.preventDefault();
        
        let current_em = $(e.target);
        let key = $(this).attr('data-key');

        let updated_qty = 0;
        let current_item = {};
        current_item[key] = updated_qty;
		 
        $.ajax({
            url: "/cart/update.js",
            data: {
                'updates': current_item
            },
            method: "POST",
            dataType: "JSON",
            success: function(data) {
                $('#cart_form').load('#cart_form>*');
                refreshCart();
                //$('.js_cart_open').addClass('js_active_class');

                $.getJSON('/cart.js', function(cart, textStatus) {
                    $(".count-item").html(cart.item_count);
                    if (cart.item_count == 0) {

                        $('.js_cart_open').removeClass('js_active_class');

                    }
					
					let cartTotal = cart.total_price;
					if(cartTotal < window.freePro1_freeamount){
						 
						$.ajax({
							type: 'POST',
							url: '/cart/change.js',
							data: {
							  quantity: 0,
							  id: window.freePro1_id
							},
							dataType: 'json',
							success: function(cart) {
							    
								refreshCart();
							},
							error: function(XMLHttpRequest, textStatus) {
							  console.log('Error: ' + textStatus);
							}
						  });
					}else if(cartTotal < window.freePro2_freeamount){
						 
						$.ajax({
							type: 'POST',
							url: '/cart/change.js',
							data: {
							  quantity: 0,
							  id: window.freePro2_id
							},
							dataType: 'json',
							success: function(cart) {
							    
								refreshCart();
							},
							error: function(XMLHttpRequest, textStatus) {
							  console.log('Error: ' + textStatus);
							}
						  });
					}else if(cartTotal < window.freePro3_freeamount){
						 
						$.ajax({
							type: 'POST',
							url: '/cart/change.js',
							data: {
							  quantity: 0,
							  id: window.freePro3_id
							},
							dataType: 'json',
							success: function(cart) {
							   
								refreshCart();
							},
							error: function(XMLHttpRequest, textStatus) {
							  console.log('Error: ' + textStatus);
							}
						  });
					}else if(cartTotal < window.freePro4_freeamount){
						 
						$.ajax({
							type: 'POST',
							url: '/cart/change.js',
							data: {
							  quantity: 0,
							  id: window.freePro4_id
							},
							dataType: 'json',
							success: function(cart) {
							   
								refreshCart();
							},
							error: function(XMLHttpRequest, textStatus) {
							  console.log('Error: ' + textStatus);
							}
						  });
					}
                });
              
                $('#sec_cart #cart_form').load('#sec_cart #cart_form > *');

            },
            error: function(error) {
                console.log(error)
            }
        });
    });

	$(document).on('click','.js_checkout',function(e){
		e.preventDefault();
		let totalqty = 0;
	   
		let itemsArray = [];
		$('[type="checkbox"]').each(function(em, ix) {
		  let currentElement = $(this);
		 
             if($(this).prop("checked") == true){
		  let vid = $(currentElement).attr('data-variant-id');
		  let qty = 1;
		  let singleItem = {id: vid, quantity: qty};
		  itemsArray.push(singleItem);
		  totalqty += parseInt(qty);
		 
		  }else{
          window.location = "/checkout";
          }
		 
		 
		  
		});
	  
		
		if($("[type='checkbox']").is(":checked") ){
		$.ajax({
		  "url"       :   "/cart/add.js",
		  "method"    :   "POST",
		  "dataType"  :   "JSON",
		  data       :   {items: itemsArray},
		  "success"   :   function(data) {
			console.log('data added');
			window.location = '/checkout';
		  },
		  "error"     :   function(data) {
			window.alert(data.responseJSON.description);
		  }
		}); 
		 
	}
		 
	
	 }); 
 
	$(document).on('click','.js_checkout_new',function(e){
		e.preventDefault();
		let totalqty = 0;
	   
		let itemsArray = [];
		$('[type="checkbox"]').each(function(em, ix) {
		  let currentElement = $(this);
		 
        if($(this).prop("checked") == true){
		  let vid = $(currentElement).attr('data-variant-id');
		  let qty = 1;
		  let singleItem = {id: vid, quantity: qty};
          
		  itemsArray.push(singleItem);
		  totalqty += parseInt(qty);
          
		 
		  }else{
          window.location = "/checkout";
          }
		 
		  
		});
	  
		
		if($("[type='checkbox']").is(":checked") ){
		$.ajax({
		  "url"       :   "/cart/add.js",
		  "method"    :   "POST",
		  "dataType"  :   "JSON",
		  data       :   {items: itemsArray},
		  "success"   :   function(data) {
			console.log('data added');
			window.location = '/checkout';
		  },
		  "error"     :   function(data) {
			window.alert(data.responseJSON.description);
		  }
		}); 
		 
	}
		 
	
	 }); 

		  
	 $(document).ready(function(){
		let homeUrl = location.href;
		if(homeUrl == 'https://www.bootea.com/#cart'){
		$(".header-cart").trigger('click'); 
		 
	   }
	 
	 });

	 $(document).ready(function() {
		$(document).on('click', '.js-sticky-buy--now', function(e){
			e.preventDefault();
			$('.product_page_buy_now').trigger('click');
		})
		if(window.innerWidth <= 991) {
			const $listItems = $('.list li');
			const visibleCount = 3;
			let expanded = false;

			function updateList() {
			$listItems.each(function (index) {
				if (index >= visibleCount) {
				$(this).toggleClass('hidden', !expanded);
				}
			});
			$('#readMoreBtn').text(expanded ? 'Read less' : 'Read more');
			}
			updateList();

			$('#readMoreBtn').on('click', function () {
			expanded = !expanded;
			updateList();
			});
		}
	})